import React from "react";

// chatui's AppHorizontalLine renders a thin <hr/>. No args.
export function AppHorizontalLine() {
  return <hr className="noetl-widget noetl-widget-horizontalline" />;
}
